
<template>
    <div class="animated fadeIn c-settings-panel">
        <b-row v-if="$router.currentRoute.name !== undefined" class="mb-2">
            <b-col>
                <b-button @click="gotoSettings" class="btn btn-light pull-left"><i class="fa fa-chevron-left"></i></b-button>
                <h5 class="pull-left ml-3 mt-2">{{$router.currentRoute.name}}</h5>
                <div style="clear: both"></div>
                <hr/>
            </b-col>
        </b-row>
        <div>
            <router-view></router-view>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'UserSettingsContainer',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
            gotoSettings() {
                if (this.$route.params.id !== undefined) {
                    let userId = this.$route.params.id
                    this.$router.push(Core.Text.format(Core.Definition.getDefinition('/systeme/utilisateurs/{0}'),userId))
                } else {
                    this.$router.push(Core.Definition.getDefinition('/compte/profil'))
                }
            }
        }
    }
</script>
